export const translations = {
  en: {
    // Navigation
    nav_dashboard: 'Dashboard',
    nav_installer_welcome: 'Welcome',
    nav_job_list: 'Jobs',
    nav_job_lifecycle: 'Job Lifecycle',
    nav_warranty_codes: 'Warranty Codes',
    nav_product_catalog: 'Product Catalog',
    nav_resellers: 'Regional Partners',
    nav_clients: 'End Clients',
    nav_installers: 'Certified Applicators',
    nav_rp_installers: 'Affiliated Applicators',
    nav_reports: 'Reports',
    nav_notifications: 'Notifications',
    nav_metrics: 'Metrics',
    nav_team_kpi: 'Team KPIs',
    nav_export_center: 'Export Center',
    nav_intl_reference: 'Intl. Reference',
    nav_contact_myfloorid: 'Contact',
    nav_territory_management: 'Territory Management',
    nav_smtp_settings: 'SMTP Settings',
    nav_email_templates: 'Email Templates',
    nav_email_automation: 'Email Automation',
    nav_data_integrity: 'Data Integrity',
    nav_maintenance_scheduler: 'Maintenance Scheduler',
    nav_audit_log: 'Audit Log',
nav_agency_management: 'Agency Management',
    nav_user_manual: 'User Manual',
    nav_app_instructions: 'App Instructions',
    nav_client_dashboard: "My Floors IDs",
    nav_floor_simulator: 'Floor Simulator',
    nav_my_floors: "My Floors ID\'s",
    nav_service_request: 'New Request',
    nav_my_requests: 'Submitted Requests',
    nav_service_requests: 'Service Requests',
    nav_new_client: 'New Client',
    nav_new_job: 'New Job',
    nav_new_floor_id: 'New Floor ID',
    nav_existing_floor_ids: 'Activated Floor IDs',
    nav_floor_ids: 'Floor IDs',
    nav_new_job_rp: 'New Job (RP)',
    nav_rp_overview: 'RP Overview',
    nav_photo_visibility: 'Photo Visibility',
    nav_warranty_inventory: 'Warranty Inventory',
    nav_warranty_scan: 'Warranty Scan',
    nav_history: 'History',
    nav_code_inventory: 'Code Inventory',
    nav_my_warranty_inventory: 'My Warranty Inventory',
    nav_assign_installers: 'Assign to Affiliated Applicators',
    nav_analytics: 'Performance Analytics',
    nav_advanced_reports: 'Advanced Reports',
    nav_client_database: 'Client Database',
    nav_rp_client_database: 'My Client Database',
    nav_performance_reports: 'Performance Reports',
    nav_batch_management: 'Batch Management',
    nav_partner_distribution: 'Partner Distribution',
    nav_sports_floor_portfolio: 'Sports Floor Portfolio',
    nav_sign_out: 'Sign Out',
    nav_job_checklist: 'Job Checklist',
    nav_offline_territory: 'Offline Territory',
    nav_field_map: 'Field Map',

    // Login Page
    login_title: 'Welcome Back',
    login_subtitle: 'Sign in to your MyFloorID account',
    login_email: 'Email Address',
    login_email_placeholder: 'Enter your email',
    login_password: 'Password',
    login_password_placeholder: 'Enter your password',
    login_remember_me: 'Remember me',
    login_forgot_password: 'Forgot password?',
    login_sign_in: 'Sign In',
    login_signing_in: 'Signing In...',
    login_accept_sign_in: 'Accept & Sign In',
    login_privacy_policy: 'Privacy Policy',
    login_terms: 'Terms of Service',
    login_need_help: 'Need help? Contact',
    login_all_rights: 'All rights reserved.',
    login_error_email_required: 'Email address is required',
    login_error_email_invalid: 'Please enter a valid email address',
    login_error_password_required: 'Password is required',
    login_error_password_length: 'Password must be at least 8 characters',
    login_error_invalid_credentials: 'Invalid email or password. Please check your credentials and try again.',
    login_error_network: 'Network error. Please try again.',

    // Common Actions
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    loading: 'Loading...',
    no_data: 'No data available',
    view_all: 'View All',
    view_details: 'View Details',
    refresh: 'Refresh',
    download: 'Download',
    upload: 'Upload',
    print: 'Print',
    share: 'Share',
    copy: 'Copy',
    select: 'Select',
    clear: 'Clear',
    apply: 'Apply',
    reset: 'Reset',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',

    // Status
    status_active: 'Active',
    status_inactive: 'Inactive',
    status_pending: 'Pending',
    status_completed: 'Completed',
    status_in_progress: 'In Progress',
    status_cancelled: 'Cancelled',
    status_expired: 'Expired',
    status_valid: 'Valid',
    status_invalid: 'Invalid',

    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Welcome',
    dashboard_total_jobs: 'Total Jobs',
    dashboard_active_warranties: 'Active Warranties',
    dashboard_pending_jobs: 'Pending Jobs',
    dashboard_completed_jobs: 'Completed Jobs',
    dashboard_recent_activity: 'Recent Activity',
    dashboard_quick_actions: 'Quick Actions',
    dashboard_system_health: 'System Health',
    dashboard_api_health: 'API Health',
    dashboard_db_connection: 'DB Connection',
    dashboard_email_delivery: 'Email Delivery',
    dashboard_job_errors: 'Job Errors (24h)',
    dashboard_warranty_activation: 'Warranty Activation',

    // Product Catalog
    product_catalog_title: 'Product Catalog Management',
    product_catalog_add: 'Add Product',
    product_catalog_total: 'Total Products',
    product_catalog_low_stock: 'Low Stock Alerts',
    product_catalog_batch_tracked: 'Batch Tracked',
    product_catalog_avg_warranty: 'Avg Warranty',
    product_catalog_name: 'Product Name',
    product_catalog_category: 'Category',
    product_catalog_floor_type: 'Floor Type',
    product_catalog_stock: 'Stock',
    product_catalog_unit: 'Unit',
    product_catalog_batch: 'Batch',
    product_catalog_expiry: 'Expiry',
    product_catalog_actions: 'Actions',
    product_catalog_search: 'Search products...',
    product_catalog_all_categories: 'All Categories',
    product_catalog_all_floor_types: 'All Floor Types',
    product_catalog_cleaners: 'Cleaners',
    product_catalog_sealers: 'Sealers & Coatings',
    product_catalog_maintenance: 'Maintenance Products',
    product_catalog_tools: 'Tools & Equipment',
    product_catalog_polish: 'Polish & Finish',

    // Job Entry
    job_entry_title: 'New Job Entry',
    job_entry_client_info: 'Client Information',
    job_entry_work_details: 'Work Details',
    job_entry_floor_specs: 'Floor Specifications',
    job_entry_products: 'Products Used',
    job_entry_photos: 'Photos',
    job_entry_documents: 'Documents',
    job_entry_signature: 'Signature',
    job_entry_location: 'Location',
    job_entry_submit: 'Submit Job',

    // Warranty
    warranty_title: 'Warranty Portal',
    warranty_code: 'Warranty Code',
    warranty_status: 'Warranty Status',
    warranty_expiry: 'Warranty Expiry',
    warranty_valid: 'Valid',
    warranty_expired: 'Expired',
    warranty_activate: 'Activate Warranty',
    warranty_certificate: 'Warranty Certificate',
    warranty_download_cert: 'Download Certificate',

    // QR / Floor Info
    qr_validating: 'Validating QR Code...',
    qr_invalid_title: 'Invalid QR Code',
    qr_invalid_desc: 'This QR code is not recognized or has been deactivated.',
    qr_go_login: 'Go to Login',
    qr_verified: 'Verified',
    qr_floor_maintenance: 'Floor Maintenance Information',
    qr_verified_by: 'Verified by Dr.Schutz',
    qr_before: 'Before',
    qr_after: 'After',
    qr_floor_type: 'Floor Type',
    qr_installation_date: 'Installation Date',
    qr_work_summary: 'Work Summary',
    qr_work_type: 'Type of Work',
    qr_description: 'Description',
    qr_products_used: 'Products Used',
    qr_performed_by: 'Work Performed By',
    qr_maintenance_status: 'Maintenance Status',
    qr_next_inspection: 'Next Inspection',
    qr_warranty_status: 'Warranty Status',
    qr_valid_until: 'Valid until',

    // Notifications
    notifications_title: 'Notifications',
    notifications_mark_all_read: 'Mark All Read',
    notifications_no_notifications: 'No notifications',
    notifications_unread: 'Unread',
    notifications_critical: 'Critical',
    notifications_today: 'Today',
    notifications_archived: 'Archived',

    // Reports
    reports_title: 'Reports',
    reports_revenue: 'Revenue',
    reports_performance: 'Performance',
    reports_geographic: 'Geographic Distribution',
    reports_executive_summary: 'Executive Summary',
    reports_strategic_insights: 'Strategic Insights',

    // Clients
    clients_title: 'Client Database',
    clients_add: 'Add Client',
    clients_name: 'Client Name',
    clients_email: 'Email',
    clients_phone: 'Phone',
    clients_location: 'Location',
    clients_type: 'Type',
    clients_status: 'Status',
    clients_jobs: 'Jobs',
    clients_search: 'Search clients...',

    // Resellers
    resellers_title: 'Regional Partner Management',
    resellers_add: 'Add Regional Partner',
    resellers_name: 'Regional Partner Name',
    resellers_region: 'Region',
    resellers_contact: 'Contact',
    resellers_status: 'Status',
    resellers_jobs: 'Jobs',

    // Analytics
    analytics_title: 'Performance Analytics',
    analytics_revenue: 'Revenue',
    analytics_jobs: 'Jobs',
    analytics_clients: 'Clients',
    analytics_products: 'Products',
    analytics_period: 'Period',

    // Installer Checklist
    checklist_title: 'Job Checklist',
    checklist_pre_job: 'Pre-Job Checklist',
    checklist_post_job: 'Post-Job Checklist',
    checklist_client_contact: 'Client contact verified',
    checklist_floor_condition: 'Floor condition documented',
    checklist_qr_scanned: 'QR code scanned',
    checklist_product_batch: 'Product batch recorded',
    checklist_photos_toggle: 'Photos public toggle confirmed',
    checklist_work_completed: 'Work completed',
    checklist_after_photos: 'After photos taken',
    checklist_client_signoff: 'Client sign-off obtained',
    checklist_warranty_activated: 'Warranty activated',
    checklist_products_logged: 'Products logged',
    checklist_submit: 'Submit Checklist',
    checklist_progress: 'Progress',

    // International Reference
    intl_ref_title: 'International Reference List',
    intl_ref_country: 'Country',
    intl_ref_client: 'Client',
    intl_ref_floor_type: 'Floor Type',
    intl_ref_year: 'Year',
    intl_ref_products: 'Products',
    intl_ref_search: 'Search references...',
    intl_ref_all_countries: 'All Countries',

    // Metrics
    metrics_title: 'End-to-End Metrics',
    metrics_agency_print: 'Agency Print',
    metrics_distribution: 'Distribution',
    metrics_activation: 'Activation',
    metrics_cert_generated: 'Cert Generated',
    metrics_system_health: 'System Health',

    // Footer / misc
    footer_rights: 'All rights reserved.',
    language_select: 'Select Language',
    page_not_found: 'Page Not Found',
    go_home: 'Go Home',
  },

  fr: {
    nav_dashboard: 'Tableau de bord',
    nav_job_list: 'Liste des travaux',
    nav_job_lifecycle: 'Cycle de vie',
    nav_warranty_codes: 'Codes de garantie',
    nav_product_catalog: 'Catalogue produits',
    nav_resellers: 'Revendeurs',
    nav_clients: 'Clients',
    nav_analytics: 'Analytique',
    nav_reports: 'Rapports',
    nav_notifications: 'Notifications',
    nav_metrics: 'Métriques',
    nav_intl_reference: 'Réf. internationale',
    nav_floor_simulator: 'Simulateur de sol',
    nav_new_job: 'Nouveau travail',
    nav_photo_visibility: 'Visibilité photos',
    nav_warranty_inventory: 'Inventaire garantie',
    nav_warranty_scan: 'Scan garantie',
    nav_history: 'Historique',
    nav_code_inventory: 'Inventaire codes',
    nav_assign_installers: 'Assigner installateurs',
    nav_advanced_reports: 'Rapports avancés',
    nav_client_database: 'Base clients',
    nav_performance_reports: 'Rapports performance',
    nav_batch_management: 'Gestion des lots',
    nav_sports_floor_portfolio: 'Portfolio sols sportifs',
    nav_sign_out: 'Déconnexion',
    nav_job_checklist: 'Liste de contrôle',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    import: 'Importer',
    close: 'Fermer',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Soumettre',
    loading: 'Chargement...',
    no_data: 'Aucune donnée disponible',
    view_all: 'Voir tout',
    view_details: 'Voir les détails',
    refresh: 'Actualiser',
    download: 'Télécharger',
    upload: 'Téléverser',
    print: 'Imprimer',
    share: 'Partager',
    copy: 'Copier',
    select: 'Sélectionner',
    clear: 'Effacer',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Avertissement',
    info: 'Info',
    status_active: 'Actif',
    status_inactive: 'Inactif',
    status_pending: 'En attente',
    status_completed: 'Terminé',
    status_in_progress: 'En cours',
    status_cancelled: 'Annulé',
    status_expired: 'Expiré',
    status_valid: 'Valide',
    status_invalid: 'Invalide',
    dashboard_title: 'Tableau de bord',
    dashboard_welcome: 'Bienvenue',
    dashboard_total_jobs: 'Total travaux',
    dashboard_active_warranties: 'Garanties actives',
    dashboard_pending_jobs: 'Travaux en attente',
    dashboard_completed_jobs: 'Travaux terminés',
    dashboard_recent_activity: 'Activité récente',
    dashboard_quick_actions: 'Actions rapides',
    dashboard_system_health: 'Santé système',
    dashboard_api_health: 'Santé API',
    dashboard_db_connection: 'Connexion BDD',
    dashboard_email_delivery: 'Livraison email',
    dashboard_job_errors: 'Erreurs travaux (24h)',
    dashboard_warranty_activation: 'Activation garantie',
    login_title: 'Bon retour',
    login_subtitle: 'Connectez-vous à votre compte MyFloorID',
    login_email: 'Adresse email',
    login_email_placeholder: 'Entrez votre email',
    login_password: 'Mot de passe',
    login_password_placeholder: 'Entrez votre mot de passe',
    login_remember_me: 'Se souvenir de moi',
    login_forgot_password: 'Mot de passe oublié ?',
    login_sign_in: 'Se connecter',
    login_signing_in: 'Connexion...',
    login_accept_sign_in: 'Accepter et se connecter',
    login_privacy_policy: 'Politique de confidentialité',
    login_terms: 'Conditions d\'utilisation',
    login_need_help: 'Besoin d\'aide ? Contactez',
    login_all_rights: 'Tous droits réservés.',
    login_error_email_required: 'L\'adresse email est requise',
    login_error_email_invalid: 'Veuillez entrer une adresse email valide',
    login_error_password_required: 'Le mot de passe est requis',
    login_error_password_length: 'Le mot de passe doit contenir au moins 8 caractères',
    login_error_invalid_credentials: 'Email ou mot de passe invalide. Veuillez vérifier vos identifiants.',
    login_error_network: 'Erreur réseau. Veuillez réessayer.',
    product_catalog_title: 'Gestion du catalogue produits',
    product_catalog_add: 'Ajouter un produit',
    product_catalog_total: 'Total produits',
    product_catalog_low_stock: 'Alertes stock bas',
    product_catalog_batch_tracked: 'Lots suivis',
    product_catalog_avg_warranty: 'Garantie moy.',
    product_catalog_name: 'Nom du produit',
    product_catalog_category: 'Catégorie',
    product_catalog_floor_type: 'Type de sol',
    product_catalog_stock: 'Stock',
    product_catalog_unit: 'Unité',
    product_catalog_batch: 'Lot',
    product_catalog_expiry: 'Expiration',
    product_catalog_actions: 'Actions',
    product_catalog_search: 'Rechercher des produits...',
    product_catalog_all_categories: 'Toutes catégories',
    product_catalog_all_floor_types: 'Tous types de sol',
    product_catalog_cleaners: 'Nettoyants',
    product_catalog_sealers: 'Scellants & Revêtements',
    product_catalog_maintenance: 'Produits d\'entretien',
    product_catalog_tools: 'Outils & Équipements',
    product_catalog_polish: 'Cire & Finition',
    qr_validating: 'Validation du code QR...',
    qr_invalid_title: 'Code QR invalide',
    qr_invalid_desc: 'Ce code QR n\'est pas reconnu ou a été désactivé.',
    qr_go_login: 'Aller à la connexion',
    qr_verified: 'Vérifié',
    qr_floor_maintenance: 'Informations d\'entretien du sol',
    qr_verified_by: 'Vérifié par Dr.Schutz',
    qr_before: 'Avant',
    qr_after: 'Après',
    qr_floor_type: 'Type de sol',
    qr_installation_date: 'Date d\'installation',
    qr_work_summary: 'Résumé des travaux',
    qr_work_type: 'Type de travaux',
    qr_description: 'Description',
    qr_products_used: 'Produits utilisés',
    qr_performed_by: 'Travaux réalisés par',
    qr_maintenance_status: 'État de maintenance',
    qr_next_inspection: 'Prochaine inspection',
    qr_warranty_status: 'État de garantie',
    qr_valid_until: 'Valide jusqu\'au',
    notifications_title: 'Notifications',
    notifications_mark_all_read: 'Tout marquer comme lu',
    notifications_no_notifications: 'Aucune notification',
    notifications_unread: 'Non lu',
    notifications_critical: 'Critique',
    notifications_today: 'Aujourd\'hui',
    notifications_archived: 'Archivé',
    reports_title: 'Rapports',
    clients_title: 'Base de données clients',
    clients_add: 'Ajouter un client',
    clients_name: 'Nom du client',
    clients_email: 'Email',
    clients_phone: 'Téléphone',
    clients_location: 'Localisation',
    clients_type: 'Type',
    clients_status: 'Statut',
    clients_jobs: 'Travaux',
    clients_search: 'Rechercher des clients...',
    resellers_title: 'Gestion des revendeurs',
    resellers_add: 'Ajouter un revendeur',
    warranty_title: 'Portail de garantie',
    warranty_code: 'Code de garantie',
    warranty_status: 'Statut de garantie',
    warranty_expiry: 'Expiration de garantie',
    warranty_valid: 'Valide',
    warranty_expired: 'Expiré',
    warranty_activate: 'Activer la garantie',
    warranty_certificate: 'Certificat de garantie',
    warranty_download_cert: 'Télécharger le certificat',
    checklist_title: 'Liste de contrôle',
    checklist_pre_job: 'Avant le travail',
    checklist_post_job: 'Après le travail',
    checklist_client_contact: 'Contact client vérifié',
    checklist_floor_condition: 'État du sol documenté',
    checklist_qr_scanned: 'Code QR scanné',
    checklist_product_batch: 'Lot de produit enregistré',
    checklist_photos_toggle: 'Visibilité photos confirmée',
    checklist_work_completed: 'Travaux terminés',
    checklist_after_photos: 'Photos après prises',
    checklist_client_signoff: 'Signature client obtenue',
    checklist_warranty_activated: 'Garantie activée',
    checklist_products_logged: 'Produits enregistrés',
    checklist_submit: 'Soumettre la liste',
    checklist_progress: 'Progression',
    intl_ref_title: 'Liste de référence internationale',
    intl_ref_country: 'Pays',
    intl_ref_client: 'Client',
    intl_ref_floor_type: 'Type de sol',
    intl_ref_year: 'Année',
    intl_ref_products: 'Produits',
    intl_ref_search: 'Rechercher...',
    intl_ref_all_countries: 'Tous les pays',
    metrics_title: 'Métriques de bout en bout',
    footer_rights: 'Tous droits réservés.',
    language_select: 'Choisir la langue',
    page_not_found: 'Page non trouvée',
    go_home: 'Accueil',
    analytics_title: 'Analytique de performance',
    job_entry_title: 'Nouveau travail',
    job_entry_client_info: 'Informations client',
    job_entry_work_details: 'Détails du travail',
    job_entry_floor_specs: 'Spécifications du sol',
    job_entry_products: 'Produits utilisés',
    job_entry_photos: 'Photos',
    job_entry_documents: 'Documents',
    job_entry_signature: 'Signature',
    job_entry_location: 'Localisation',
    job_entry_submit: 'Soumettre le travail',
  },

  de: {
    nav_dashboard: 'Dashboard',
    nav_job_list: 'Auftragsliste',
    nav_job_lifecycle: 'Auftragslebenszyklus',
    nav_warranty_codes: 'Garantiecodes',
    nav_product_catalog: 'Produktkatalog',
    nav_resellers: 'Händler',
    nav_clients: 'Kunden',
    nav_analytics: 'Analytik',
    nav_reports: 'Berichte',
    nav_notifications: 'Benachrichtigungen',
    nav_metrics: 'Metriken',
    nav_intl_reference: 'Intl. Referenz',
    nav_floor_simulator: 'Bodensimulator',
    nav_new_job: 'Neuer Auftrag',
    nav_photo_visibility: 'Foto-Sichtbarkeit',
    nav_warranty_inventory: 'Garantiebestand',
    nav_warranty_scan: 'Garantie-Scan',
    nav_history: 'Verlauf',
    nav_code_inventory: 'Code-Bestand',
    nav_assign_installers: 'Installateure zuweisen',
    nav_advanced_reports: 'Erweiterte Berichte',
    nav_client_database: 'Kundendatenbank',
    nav_performance_reports: 'Leistungsberichte',
    nav_batch_management: 'Chargenverwaltung',
    nav_sports_floor_portfolio: 'Sportboden-Portfolio',
    nav_sign_out: 'Abmelden',
    nav_job_checklist: 'Auftragscheckliste',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    search: 'Suchen',
    filter: 'Filtern',
    export: 'Exportieren',
    import: 'Importieren',
    close: 'Schließen',
    confirm: 'Bestätigen',
    back: 'Zurück',
    next: 'Weiter',
    submit: 'Einreichen',
    loading: 'Laden...',
    no_data: 'Keine Daten verfügbar',
    view_all: 'Alle anzeigen',
    view_details: 'Details anzeigen',
    refresh: 'Aktualisieren',
    download: 'Herunterladen',
    upload: 'Hochladen',
    print: 'Drucken',
    share: 'Teilen',
    copy: 'Kopieren',
    select: 'Auswählen',
    clear: 'Löschen',
    apply: 'Anwenden',
    reset: 'Zurücksetzen',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    info: 'Info',
    status_active: 'Aktiv',
    status_inactive: 'Inaktiv',
    status_pending: 'Ausstehend',
    status_completed: 'Abgeschlossen',
    status_in_progress: 'In Bearbeitung',
    status_cancelled: 'Abgebrochen',
    status_expired: 'Abgelaufen',
    status_valid: 'Gültig',
    status_invalid: 'Ungültig',
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Willkommen',
    dashboard_total_jobs: 'Aufträge gesamt',
    dashboard_active_warranties: 'Aktive Garantien',
    dashboard_pending_jobs: 'Ausstehende Aufträge',
    dashboard_completed_jobs: 'Abgeschlossene Aufträge',
    dashboard_recent_activity: 'Letzte Aktivität',
    dashboard_quick_actions: 'Schnellaktionen',
    dashboard_system_health: 'Systemzustand',
    dashboard_api_health: 'API-Zustand',
    dashboard_db_connection: 'DB-Verbindung',
    dashboard_email_delivery: 'E-Mail-Zustellung',
    dashboard_job_errors: 'Auftragsfehler (24h)',
    dashboard_warranty_activation: 'Garantieaktivierung',
    login_title: 'Willkommen zurück',
    login_subtitle: 'Melden Sie sich bei Ihrem MyFloorID-Konto an',
    login_email: 'E-Mail-Adresse',
    login_email_placeholder: 'E-Mail eingeben',
    login_password: 'Passwort',
    login_password_placeholder: 'Passwort eingeben',
    login_remember_me: 'Angemeldet bleiben',
    login_forgot_password: 'Passwort vergessen?',
    login_sign_in: 'Anmelden',
    login_signing_in: 'Anmeldung...',
    login_accept_sign_in: 'Akzeptieren & Anmelden',
    login_privacy_policy: 'Datenschutzrichtlinie',
    login_terms: 'Nutzungsbedingungen',
    login_need_help: 'Hilfe benötigt? Kontakt',
    login_all_rights: 'Alle Rechte vorbehalten.',
    login_error_email_required: 'E-Mail-Adresse ist erforderlich',
    login_error_email_invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    login_error_password_required: 'Passwort ist erforderlich',
    login_error_password_length: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    login_error_invalid_credentials: 'Ungültige E-Mail oder Passwort. Bitte überprüfen Sie Ihre Anmeldedaten.',
    login_error_network: 'Netzwerkfehler. Bitte versuchen Sie es erneut.',
    product_catalog_title: 'Produktkatalog-Verwaltung',
    product_catalog_add: 'Produkt hinzufügen',
    product_catalog_total: 'Produkte gesamt',
    product_catalog_low_stock: 'Niedrigbestand-Warnungen',
    product_catalog_batch_tracked: 'Chargen verfolgt',
    product_catalog_avg_warranty: 'Ø Garantie',
    product_catalog_name: 'Produktname',
    product_catalog_category: 'Kategorie',
    product_catalog_floor_type: 'Bodentyp',
    product_catalog_stock: 'Bestand',
    product_catalog_unit: 'Einheit',
    product_catalog_batch: 'Charge',
    product_catalog_expiry: 'Ablauf',
    product_catalog_actions: 'Aktionen',
    product_catalog_search: 'Produkte suchen...',
    product_catalog_all_categories: 'Alle Kategorien',
    product_catalog_all_floor_types: 'Alle Bodentypen',
    product_catalog_cleaners: 'Reiniger',
    product_catalog_sealers: 'Versiegelungen & Beschichtungen',
    product_catalog_maintenance: 'Pflegeprodukte',
    product_catalog_tools: 'Werkzeuge & Ausrüstung',
    product_catalog_polish: 'Politur & Finish',
    qr_validating: 'QR-Code wird validiert...',
    qr_invalid_title: 'Ungültiger QR-Code',
    qr_invalid_desc: 'Dieser QR-Code wird nicht erkannt oder wurde deaktiviert.',
    qr_go_login: 'Zur Anmeldung',
    qr_verified: 'Verifiziert',
    qr_floor_maintenance: 'Bodenpflegeinformationen',
    qr_verified_by: 'Verifiziert von Dr.Schutz',
    qr_before: 'Vorher',
    qr_after: 'Nachher',
    qr_floor_type: 'Bodentyp',
    qr_installation_date: 'Installationsdatum',
    qr_work_summary: 'Arbeitszusammenfassung',
    qr_work_type: 'Arbeitsart',
    qr_description: 'Beschreibung',
    qr_products_used: 'Verwendete Produkte',
    qr_performed_by: 'Ausgeführt von',
    qr_maintenance_status: 'Wartungsstatus',
    qr_next_inspection: 'Nächste Inspektion',
    qr_warranty_status: 'Garantiestatus',
    qr_valid_until: 'Gültig bis',
    notifications_title: 'Benachrichtigungen',
    notifications_mark_all_read: 'Alle als gelesen markieren',
    notifications_no_notifications: 'Keine Benachrichtigungen',
    notifications_unread: 'Ungelesen',
    notifications_critical: 'Kritisch',
    notifications_today: 'Heute',
    notifications_archived: 'Archiviert',
    reports_title: 'Berichte',
    clients_title: 'Kundendatenbank',
    clients_add: 'Kunde hinzufügen',
    clients_name: 'Kundenname',
    clients_email: 'E-Mail',
    clients_phone: 'Telefon',
    clients_location: 'Standort',
    clients_type: 'Typ',
    clients_status: 'Status',
    clients_jobs: 'Aufträge',
    clients_search: 'Kunden suchen...',
    resellers_title: 'Händlerverwaltung',
    resellers_add: 'Händler hinzufügen',
    warranty_title: 'Garantieportal',
    warranty_code: 'Garantiecode',
    warranty_status: 'Garantiestatus',
    warranty_expiry: 'Garantieablauf',
    warranty_valid: 'Gültig',
    warranty_expired: 'Abgelaufen',
    warranty_activate: 'Garantie aktivieren',
    warranty_certificate: 'Garantiezertifikat',
    warranty_download_cert: 'Zertifikat herunterladen',
    checklist_title: 'Auftragscheckliste',
    checklist_pre_job: 'Vor dem Auftrag',
    checklist_post_job: 'Nach dem Auftrag',
    checklist_client_contact: 'Kundenkontakt verifiziert',
    checklist_floor_condition: 'Bodenzustand dokumentiert',
    checklist_qr_scanned: 'QR-Code gescannt',
    checklist_product_batch: 'Produktcharge erfasst',
    checklist_photos_toggle: 'Foto-Sichtbarkeit bestätigt',
    checklist_work_completed: 'Arbeiten abgeschlossen',
    checklist_after_photos: 'Nachher-Fotos aufgenommen',
    checklist_client_signoff: 'Kundenunterschrift erhalten',
    checklist_warranty_activated: 'Garantie aktiviert',
    checklist_products_logged: 'Produkte erfasst',
    checklist_submit: 'Checkliste einreichen',
    checklist_progress: 'Fortschritt',
    intl_ref_title: 'Internationale Referenzliste',
    intl_ref_country: 'Land',
    intl_ref_client: 'Kunde',
    intl_ref_floor_type: 'Bodentyp',
    intl_ref_year: 'Jahr',
    intl_ref_products: 'Produkte',
    intl_ref_search: 'Referenzen suchen...',
    intl_ref_all_countries: 'Alle Länder',
    metrics_title: 'End-to-End-Metriken',
    footer_rights: 'Alle Rechte vorbehalten.',
    language_select: 'Sprache wählen',
    page_not_found: 'Seite nicht gefunden',
    go_home: 'Startseite',
    analytics_title: 'Leistungsanalytik',
    job_entry_title: 'Neuer Auftrag',
    job_entry_client_info: 'Kundeninformationen',
    job_entry_work_details: 'Arbeitsdetails',
    job_entry_floor_specs: 'Bodenspezifikationen',
    job_entry_products: 'Verwendete Produkte',
    job_entry_photos: 'Fotos',
    job_entry_documents: 'Dokumente',
    job_entry_signature: 'Unterschrift',
    job_entry_location: 'Standort',
    job_entry_submit: 'Auftrag einreichen',
  },

  it: {
    nav_dashboard: 'Dashboard',
    nav_job_list: 'Lista lavori',
    nav_job_lifecycle: 'Ciclo di vita',
    nav_warranty_codes: 'Codici garanzia',
    nav_product_catalog: 'Catalogo prodotti',
    nav_resellers: 'Rivenditori',
    nav_clients: 'Clienti',
    nav_analytics: 'Analisi',
    nav_reports: 'Rapporti',
    nav_notifications: 'Notifiche',
    nav_metrics: 'Metriche',
    nav_intl_reference: 'Rif. internazionale',
    nav_floor_simulator: 'Simulatore pavimento',
    nav_new_job: 'Nuovo lavoro',
    nav_photo_visibility: 'Visibilità foto',
    nav_warranty_inventory: 'Inventario garanzia',
    nav_warranty_scan: 'Scansione garanzia',
    nav_history: 'Cronologia',
    nav_code_inventory: 'Inventario codici',
    nav_assign_installers: 'Assegna installatori',
    nav_advanced_reports: 'Rapporti avanzati',
    nav_client_database: 'Database clienti',
    nav_performance_reports: 'Rapporti performance',
    nav_batch_management: 'Gestione lotti',
    nav_sports_floor_portfolio: 'Portfolio pavimenti sportivi',
    nav_sign_out: 'Disconnetti',
    nav_job_checklist: 'Lista di controllo',
    save: 'Salva', cancel: 'Annulla', delete: 'Elimina', edit: 'Modifica', add: 'Aggiungi',
    search: 'Cerca', filter: 'Filtra', export: 'Esporta', import: 'Importa', close: 'Chiudi',
    confirm: 'Conferma', back: 'Indietro', next: 'Avanti', submit: 'Invia', loading: 'Caricamento...',
    no_data: 'Nessun dato disponibile', view_all: 'Vedi tutto', view_details: 'Vedi dettagli',
    refresh: 'Aggiorna', download: 'Scarica', upload: 'Carica', print: 'Stampa', share: 'Condividi',
    copy: 'Copia', select: 'Seleziona', clear: 'Cancella', apply: 'Applica', reset: 'Reimposta',
    yes: 'Sì', no: 'No', ok: 'OK', error: 'Errore', success: 'Successo', warning: 'Avviso', info: 'Info',
    status_active: 'Attivo', status_inactive: 'Inattivo', status_pending: 'In attesa',
    status_completed: 'Completato', status_in_progress: 'In corso', status_cancelled: 'Annullato',
    status_expired: 'Scaduto', status_valid: 'Valido', status_invalid: 'Non valido',
    dashboard_title: 'Dashboard', dashboard_welcome: 'Benvenuto',
    dashboard_total_jobs: 'Lavori totali', dashboard_active_warranties: 'Garanzie attive',
    dashboard_pending_jobs: 'Lavori in attesa', dashboard_completed_jobs: 'Lavori completati',
    dashboard_recent_activity: 'Attività recente', dashboard_quick_actions: 'Azioni rapide',
    dashboard_system_health: 'Salute sistema', dashboard_api_health: 'Salute API',
    dashboard_db_connection: 'Connessione DB', dashboard_email_delivery: 'Consegna email',
    dashboard_job_errors: 'Errori lavori (24h)', dashboard_warranty_activation: 'Attivazione garanzia',
    login_title: 'Bentornato', login_subtitle: 'Accedi al tuo account MyFloorID',
    login_email: 'Indirizzo email', login_email_placeholder: 'Inserisci la tua email',
    login_password: 'Password', login_password_placeholder: 'Inserisci la tua password',
    login_remember_me: 'Ricordami', login_forgot_password: 'Password dimenticata?',
    login_sign_in: 'Accedi', login_signing_in: 'Accesso...', login_accept_sign_in: 'Accetta e accedi',
    login_privacy_policy: 'Informativa sulla privacy', login_terms: 'Termini di servizio',
    login_need_help: 'Hai bisogno di aiuto? Contatta', login_all_rights: 'Tutti i diritti riservati.',
    login_error_email_required: 'L\'indirizzo email è obbligatorio',
    login_error_email_invalid: 'Inserisci un indirizzo email valido',
    login_error_password_required: 'La password è obbligatoria',
    login_error_password_length: 'La password deve contenere almeno 8 caratteri',
    login_error_invalid_credentials: 'Email o password non validi.',
    login_error_network: 'Errore di rete. Riprova.',
    product_catalog_title: 'Gestione catalogo prodotti', product_catalog_add: 'Aggiungi prodotto',
    product_catalog_total: 'Prodotti totali', product_catalog_low_stock: 'Avvisi scorte basse',
    product_catalog_batch_tracked: 'Lotti tracciati', product_catalog_avg_warranty: 'Garanzia media',
    product_catalog_name: 'Nome prodotto', product_catalog_category: 'Categoria',
    product_catalog_floor_type: 'Tipo pavimento', product_catalog_stock: 'Scorte',
    product_catalog_unit: 'Unità', product_catalog_batch: 'Lotto', product_catalog_expiry: 'Scadenza',
    product_catalog_actions: 'Azioni', product_catalog_search: 'Cerca prodotti...',
    product_catalog_all_categories: 'Tutte le categorie', product_catalog_all_floor_types: 'Tutti i tipi',
    product_catalog_cleaners: 'Detergenti', product_catalog_sealers: 'Sigillanti & Rivestimenti',
    product_catalog_maintenance: 'Prodotti manutenzione', product_catalog_tools: 'Strumenti & Attrezzature',
    product_catalog_polish: 'Lucidante & Finitura',
    qr_validating: 'Validazione codice QR...', qr_invalid_title: 'Codice QR non valido',
    qr_invalid_desc: 'Questo codice QR non è riconosciuto o è stato disattivato.',
    qr_go_login: 'Vai al login', qr_verified: 'Verificato',
    qr_floor_maintenance: 'Informazioni manutenzione pavimento', qr_verified_by: 'Verificato da Dr.Schutz',
    qr_before: 'Prima', qr_after: 'Dopo', qr_floor_type: 'Tipo pavimento',
    qr_installation_date: 'Data installazione', qr_work_summary: 'Riepilogo lavori',
    qr_work_type: 'Tipo di lavoro', qr_description: 'Descrizione', qr_products_used: 'Prodotti utilizzati',
    qr_performed_by: 'Lavori eseguiti da', qr_maintenance_status: 'Stato manutenzione',
    qr_next_inspection: 'Prossima ispezione', qr_warranty_status: 'Stato garanzia',
    qr_valid_until: 'Valido fino al',
    notifications_title: 'Notifiche', notifications_mark_all_read: 'Segna tutto come letto',
    notifications_no_notifications: 'Nessuna notifica', notifications_unread: 'Non letto',
    notifications_critical: 'Critico', notifications_today: 'Oggi', notifications_archived: 'Archiviato',
    reports_title: 'Rapporti', clients_title: 'Database clienti', clients_add: 'Aggiungi cliente',
    clients_name: 'Nome cliente', clients_email: 'Email', clients_phone: 'Telefono',
    clients_location: 'Posizione', clients_type: 'Tipo', clients_status: 'Stato', clients_jobs: 'Lavori',
    clients_search: 'Cerca clienti...', resellers_title: 'Gestione rivenditori', resellers_add: 'Aggiungi rivenditore',
    warranty_title: 'Portale garanzia', warranty_code: 'Codice garanzia', warranty_status: 'Stato garanzia',
    warranty_expiry: 'Scadenza garanzia', warranty_valid: 'Valido', warranty_expired: 'Scaduto',
    warranty_activate: 'Attiva garanzia', warranty_certificate: 'Certificato garanzia',
    warranty_download_cert: 'Scarica certificato',
    checklist_title: 'Lista di controllo', checklist_pre_job: 'Prima del lavoro',
    checklist_post_job: 'Dopo il lavoro', checklist_client_contact: 'Contatto cliente verificato',
    checklist_floor_condition: 'Condizione pavimento documentata', checklist_qr_scanned: 'Codice QR scansionato',
    checklist_product_batch: 'Lotto prodotto registrato', checklist_photos_toggle: 'Visibilità foto confermata',
    checklist_work_completed: 'Lavori completati', checklist_after_photos: 'Foto dopo scattate',
    checklist_client_signoff: 'Firma cliente ottenuta', checklist_warranty_activated: 'Garanzia attivata',
    checklist_products_logged: 'Prodotti registrati', checklist_submit: 'Invia lista',
    checklist_progress: 'Progresso',
    intl_ref_title: 'Lista di riferimento internazionale', intl_ref_country: 'Paese',
    intl_ref_client: 'Cliente', intl_ref_floor_type: 'Tipo pavimento', intl_ref_year: 'Anno',
    intl_ref_products: 'Prodotti', intl_ref_search: 'Cerca riferimenti...', intl_ref_all_countries: 'Tutti i paesi',
    metrics_title: 'Metriche end-to-end', footer_rights: 'Tutti i diritti riservati.',
    language_select: 'Seleziona lingua', page_not_found: 'Pagina non trovata', go_home: 'Home',
    analytics_title: 'Analisi delle performance', job_entry_title: 'Nuovo lavoro',
    job_entry_client_info: 'Informazioni cliente', job_entry_work_details: 'Dettagli lavoro',
    job_entry_floor_specs: 'Specifiche pavimento', job_entry_products: 'Prodotti utilizzati',
    job_entry_photos: 'Foto', job_entry_documents: 'Documenti', job_entry_signature: 'Firma',
    job_entry_location: 'Posizione', job_entry_submit: 'Invia lavoro',
  },

  da: {
    nav_dashboard: 'Dashboard', nav_job_list: 'Jobliste', nav_job_lifecycle: 'Joblivscyklus',
    nav_warranty_codes: 'Garantikoder', nav_product_catalog: 'Produktkatalog',
    nav_resellers: 'Forhandlere', nav_clients: 'Kunder', nav_analytics: 'Analyse',
    nav_reports: 'Rapporter', nav_notifications: 'Notifikationer', nav_metrics: 'Målinger',
    nav_intl_reference: 'Intl. reference', nav_floor_simulator: 'Gulvsimulator',
    nav_new_job: 'Nyt job', nav_photo_visibility: 'Fotosynlighed', nav_warranty_inventory: 'Garantibeholdning',
    nav_warranty_scan: 'Garantiscanning', nav_history: 'Historik', nav_code_inventory: 'Kodebeholdning',
    nav_assign_installers: 'Tildel installatører', nav_advanced_reports: 'Avancerede rapporter',
    nav_client_database: 'Kundedatabase', nav_performance_reports: 'Performancerapporter',
    nav_batch_management: 'Batchstyring', nav_sports_floor_portfolio: 'Sportsgulvportefølje',
    nav_sign_out: 'Log ud', nav_job_checklist: 'Jobliste',
    save: 'Gem', cancel: 'Annuller', delete: 'Slet', edit: 'Rediger', add: 'Tilføj',
    search: 'Søg', filter: 'Filtrer', export: 'Eksporter', import: 'Importer', close: 'Luk',
    confirm: 'Bekræft', back: 'Tilbage', next: 'Næste', submit: 'Indsend', loading: 'Indlæser...',
    no_data: 'Ingen data tilgængelig', view_all: 'Se alle', view_details: 'Se detaljer',
    yes: 'Ja', no: 'Nej', ok: 'OK', error: 'Fejl', success: 'Succes', warning: 'Advarsel', info: 'Info',
    status_active: 'Aktiv', status_inactive: 'Inaktiv', status_pending: 'Afventer',
    status_completed: 'Afsluttet', status_in_progress: 'I gang', status_cancelled: 'Annulleret',
    status_expired: 'Udløbet', status_valid: 'Gyldig', status_invalid: 'Ugyldig',
    dashboard_title: 'Dashboard', dashboard_welcome: 'Velkommen',
    dashboard_total_jobs: 'Samlede job', dashboard_active_warranties: 'Aktive garantier',
    dashboard_pending_jobs: 'Afventende job', dashboard_completed_jobs: 'Afsluttede job',
    login_title: 'Velkommen tilbage', login_subtitle: 'Log ind på din MyFloorID-konto',
    login_email: 'E-mailadresse', login_email_placeholder: 'Indtast din e-mail',
    login_password: 'Adgangskode', login_password_placeholder: 'Indtast din adgangskode',
    login_remember_me: 'Husk mig', login_forgot_password: 'Glemt adgangskode?',
    login_sign_in: 'Log ind', login_signing_in: 'Logger ind...', login_accept_sign_in: 'Accepter og log ind',
    login_privacy_policy: 'Privatlivspolitik', login_terms: 'Servicevilkår',
    login_need_help: 'Brug for hjælp? Kontakt', login_all_rights: 'Alle rettigheder forbeholdes.',
    login_error_email_required: 'E-mailadresse er påkrævet',
    login_error_email_invalid: 'Indtast en gyldig e-mailadresse',
    login_error_password_required: 'Adgangskode er påkrævet',
    login_error_password_length: 'Adgangskoden skal være mindst 8 tegn',
    login_error_invalid_credentials: 'Ugyldig e-mail eller adgangskode.',
    login_error_network: 'Netværksfejl. Prøv igen.',
    product_catalog_title: 'Produktkatalog-administration', product_catalog_add: 'Tilføj produkt',
    product_catalog_total: 'Produkter i alt', product_catalog_low_stock: 'Lavt lager-advarsler',
    product_catalog_name: 'Produktnavn', product_catalog_category: 'Kategori',
    product_catalog_floor_type: 'Gulvtype', product_catalog_stock: 'Lager',
    product_catalog_search: 'Søg produkter...', product_catalog_all_categories: 'Alle kategorier',
    product_catalog_cleaners: 'Rengøringsmidler', product_catalog_sealers: 'Forseglinger & Belægninger',
    product_catalog_maintenance: 'Vedligeholdelses-produkter', product_catalog_tools: 'Værktøj & Udstyr',
    product_catalog_polish: 'Polering & Finish',
    qr_validating: 'Validerer QR-kode...', qr_invalid_title: 'Ugyldig QR-kode',
    qr_invalid_desc: 'Denne QR-kode genkendes ikke eller er blevet deaktiveret.',
    qr_go_login: 'Gå til login', qr_verified: 'Verificeret',
    qr_floor_maintenance: 'Gulvvedligeholdelsesinformation', qr_verified_by: 'Verificeret af Dr.Schutz',
    qr_before: 'Før', qr_after: 'Efter', qr_floor_type: 'Gulvtype',
    qr_installation_date: 'Installationsdato', qr_work_summary: 'Arbejdsoversigt',
    qr_products_used: 'Anvendte produkter', qr_performed_by: 'Arbejde udført af',
    qr_maintenance_status: 'Vedligeholdelsesstatus', qr_next_inspection: 'Næste inspektion',
    qr_warranty_status: 'Garantistatus', qr_valid_until: 'Gyldig til',
    notifications_title: 'Notifikationer', notifications_mark_all_read: 'Markér alle som læst',
    notifications_no_notifications: 'Ingen notifikationer',
    checklist_title: 'Jobliste', checklist_pre_job: 'Før jobbet', checklist_post_job: 'Efter jobbet',
    intl_ref_title: 'International referenceliste', intl_ref_country: 'Land',
    footer_rights: 'Alle rettigheder forbeholdes.', language_select: 'Vælg sprog',
    page_not_found: 'Side ikke fundet', go_home: 'Hjem',
  },

  cs: {
    nav_dashboard: 'Přehled', nav_job_list: 'Seznam zakázek', nav_job_lifecycle: 'Životní cyklus zakázky',
    nav_warranty_codes: 'Záruční kódy', nav_product_catalog: 'Katalog produktů',
    nav_resellers: 'Prodejci', nav_clients: 'Klienti', nav_analytics: 'Analytika',
    nav_reports: 'Zprávy', nav_notifications: 'Oznámení', nav_metrics: 'Metriky',
    nav_intl_reference: 'Mezinár. reference', nav_floor_simulator: 'Simulátor podlahy',
    nav_new_job: 'Nová zakázka', nav_photo_visibility: 'Viditelnost fotek',
    nav_warranty_inventory: 'Záruční sklad', nav_warranty_scan: 'Záruční sken',
    nav_history: 'Historie', nav_code_inventory: 'Sklad kódů',
    nav_assign_installers: 'Přiřadit instalatéry', nav_advanced_reports: 'Pokročilé zprávy',
    nav_client_database: 'Databáze klientů', nav_performance_reports: 'Zprávy výkonu',
    nav_batch_management: 'Správa šarží', nav_sports_floor_portfolio: 'Portfolio sportovních podlah',
    nav_sign_out: 'Odhlásit se', nav_job_checklist: 'Kontrolní seznam',
    save: 'Uložit', cancel: 'Zrušit', delete: 'Smazat', edit: 'Upravit', add: 'Přidat',
    search: 'Hledat', filter: 'Filtrovat', export: 'Exportovat', close: 'Zavřít',
    confirm: 'Potvrdit', back: 'Zpět', next: 'Další', submit: 'Odeslat', loading: 'Načítání...',
    no_data: 'Žádná data k dispozici', yes: 'Ano', no: 'Ne', ok: 'OK',
    error: 'Chyba', success: 'Úspěch', warning: 'Varování',
    status_active: 'Aktivní', status_inactive: 'Neaktivní', status_pending: 'Čekající',
    status_completed: 'Dokončeno', status_in_progress: 'Probíhá', status_cancelled: 'Zrušeno',
    status_expired: 'Vypršelo', status_valid: 'Platný', status_invalid: 'Neplatný',
    dashboard_title: 'Přehled', dashboard_welcome: 'Vítejte',
    login_title: 'Vítejte zpět', login_subtitle: 'Přihlaste se ke svému účtu MyFloorID',
    login_email: 'E-mailová adresa', login_email_placeholder: 'Zadejte svůj e-mail',
    login_password: 'Heslo', login_password_placeholder: 'Zadejte své heslo',
    login_remember_me: 'Zapamatovat si mě', login_forgot_password: 'Zapomněli jste heslo?',
    login_sign_in: 'Přihlásit se', login_signing_in: 'Přihlašování...',
    login_accept_sign_in: 'Přijmout a přihlásit se',
    login_privacy_policy: 'Zásady ochrany osobních údajů', login_terms: 'Podmínky služby',
    login_need_help: 'Potřebujete pomoc? Kontaktujte', login_all_rights: 'Všechna práva vyhrazena.',
    login_error_email_required: 'E-mailová adresa je povinná',
    login_error_email_invalid: 'Zadejte platnou e-mailovou adresu',
    login_error_password_required: 'Heslo je povinné',
    login_error_password_length: 'Heslo musí mít alespoň 8 znaků',
    login_error_invalid_credentials: 'Neplatný e-mail nebo heslo.',
    login_error_network: 'Chyba sítě. Zkuste to znovu.',
    product_catalog_title: 'Správa katalogu produktů', product_catalog_add: 'Přidat produkt',
    product_catalog_search: 'Hledat produkty...', product_catalog_all_categories: 'Všechny kategorie',
    product_catalog_cleaners: 'Čisticí prostředky', product_catalog_sealers: 'Těsniva & Nátěry',
    product_catalog_maintenance: 'Údržbové produkty', product_catalog_tools: 'Nástroje & Vybavení',
    product_catalog_polish: 'Leštidla & Finish',
    qr_validating: 'Ověřování QR kódu...', qr_invalid_title: 'Neplatný QR kód',
    qr_invalid_desc: 'Tento QR kód není rozpoznán nebo byl deaktivován.',
    qr_go_login: 'Přejít na přihlášení', qr_verified: 'Ověřeno',
    qr_floor_maintenance: 'Informace o údržbě podlahy', qr_verified_by: 'Ověřeno Dr.Schutz',
    qr_before: 'Před', qr_after: 'Po', qr_floor_type: 'Typ podlahy',
    qr_installation_date: 'Datum instalace', qr_work_summary: 'Přehled prací',
    qr_products_used: 'Použité produkty', qr_performed_by: 'Práce provedl',
    qr_maintenance_status: 'Stav údržby', qr_next_inspection: 'Příští inspekce',
    qr_warranty_status: 'Stav záruky', qr_valid_until: 'Platný do',
    notifications_title: 'Oznámení', notifications_mark_all_read: 'Označit vše jako přečtené',
    notifications_no_notifications: 'Žádná oznámení',
    checklist_title: 'Kontrolní seznam', checklist_pre_job: 'Před zakázkou', checklist_post_job: 'Po zakázce',
    intl_ref_title: 'Mezinárodní referenční seznam', intl_ref_country: 'Země',
    footer_rights: 'Všechna práva vyhrazena.', language_select: 'Vybrat jazyk',
    page_not_found: 'Stránka nenalezena', go_home: 'Domů',
  },

  hu: {
    nav_dashboard: 'Irányítópult', nav_job_list: 'Munkák listája', nav_job_lifecycle: 'Munka életciklusa',
    nav_warranty_codes: 'Garancia kódok', nav_product_catalog: 'Termékkatalógus',
    nav_resellers: 'Viszonteladók', nav_clients: 'Ügyfelek', nav_analytics: 'Elemzés',
    nav_reports: 'Jelentések', nav_notifications: 'Értesítések', nav_metrics: 'Mérőszámok',
    nav_intl_reference: 'Nemz. referencia', nav_floor_simulator: 'Padló szimulátor',
    nav_new_job: 'Új munka', nav_photo_visibility: 'Fotó láthatóság',
    nav_warranty_inventory: 'Garancia készlet', nav_warranty_scan: 'Garancia szkennelés',
    nav_history: 'Előzmények', nav_code_inventory: 'Kód készlet',
    nav_assign_installers: 'Szerelők hozzárendelése', nav_advanced_reports: 'Speciális jelentések',
    nav_client_database: 'Ügyfél adatbázis', nav_performance_reports: 'Teljesítmény jelentések',
    nav_batch_management: 'Köteg kezelés', nav_sports_floor_portfolio: 'Sportpadló portfólió',
    nav_sign_out: 'Kijelentkezés', nav_job_checklist: 'Ellenőrzőlista',
    save: 'Mentés', cancel: 'Mégse', delete: 'Törlés', edit: 'Szerkesztés', add: 'Hozzáadás',
    search: 'Keresés', filter: 'Szűrés', export: 'Exportálás', close: 'Bezárás',
    confirm: 'Megerősítés', back: 'Vissza', next: 'Következő', submit: 'Beküldés', loading: 'Betöltés...',
    no_data: 'Nincs elérhető adat', yes: 'Igen', no: 'Nem', ok: 'OK',
    error: 'Hiba', success: 'Siker', warning: 'Figyelmeztetés',
    status_active: 'Aktív', status_inactive: 'Inaktív', status_pending: 'Függőben',
    status_completed: 'Befejezett', status_in_progress: 'Folyamatban', status_cancelled: 'Törölve',
    status_expired: 'Lejárt', status_valid: 'Érvényes', status_invalid: 'Érvénytelen',
    dashboard_title: 'Irányítópult', dashboard_welcome: 'Üdvözöljük',
    login_title: 'Üdvözöljük vissza', login_subtitle: 'Jelentkezzen be MyFloorID fiókjába',
    login_email: 'E-mail cím', login_email_placeholder: 'Adja meg e-mail címét',
    login_password: 'Jelszó', login_password_placeholder: 'Adja meg jelszavát',
    login_remember_me: 'Emlékezzen rám', login_forgot_password: 'Elfelejtette jelszavát?',
    login_sign_in: 'Bejelentkezés', login_signing_in: 'Bejelentkezés...',
    login_accept_sign_in: 'Elfogadás és bejelentkezés',
    login_privacy_policy: 'Adatvédelmi irányelvek', login_terms: 'Szolgáltatási feltételek',
    login_need_help: 'Segítségre van szüksége? Kapcsolat', login_all_rights: 'Minden jog fenntartva.',
    login_error_email_required: 'Az e-mail cím kötelező',
    login_error_email_invalid: 'Adjon meg érvényes e-mail címet',
    login_error_password_required: 'A jelszó kötelező',
    login_error_password_length: 'A jelszónak legalább 8 karakterből kell állnia',
    login_error_invalid_credentials: 'Érvénytelen e-mail vagy jelszó.',
    login_error_network: 'Hálózati hiba. Kérjük, próbálja újra.',
    product_catalog_title: 'Termékkatalógus kezelés', product_catalog_add: 'Termék hozzáadása',
    product_catalog_search: 'Termékek keresése...', product_catalog_all_categories: 'Minden kategória',
    product_catalog_cleaners: 'Tisztítószerek', product_catalog_sealers: 'Tömítők & Bevonatok',
    product_catalog_maintenance: 'Karbantartási termékek', product_catalog_tools: 'Eszközök & Felszerelések',
    product_catalog_polish: 'Polírozó & Befejező',
    qr_validating: 'QR kód ellenőrzése...', qr_invalid_title: 'Érvénytelen QR kód',
    qr_invalid_desc: 'Ez a QR kód nem ismerhető fel vagy deaktiválva lett.',
    qr_go_login: 'Bejelentkezéshez', qr_verified: 'Ellenőrzött',
    qr_floor_maintenance: 'Padló karbantartási információk', qr_verified_by: 'Ellenőrizte Dr.Schutz',
    qr_before: 'Előtte', qr_after: 'Utána', qr_floor_type: 'Padló típusa',
    qr_installation_date: 'Telepítés dátuma', qr_work_summary: 'Munka összefoglalója',
    qr_products_used: 'Felhasznált termékek', qr_performed_by: 'Munkát végezte',
    qr_maintenance_status: 'Karbantartás állapota', qr_next_inspection: 'Következő ellenőrzés',
    qr_warranty_status: 'Garancia állapota', qr_valid_until: 'Érvényes',
    notifications_title: 'Értesítések', notifications_mark_all_read: 'Összes olvasottnak jelölése',
    notifications_no_notifications: 'Nincs értesítés',
    checklist_title: 'Ellenőrzőlista', checklist_pre_job: 'Munka előtt', checklist_post_job: 'Munka után',
    intl_ref_title: 'Nemzetközi referencia lista', intl_ref_country: 'Ország',
    footer_rights: 'Minden jog fenntartva.', language_select: 'Nyelv kiválasztása',
    page_not_found: 'Az oldal nem található', go_home: 'Főoldal',
  },

  pl: {
    nav_dashboard: 'Panel', nav_job_list: 'Lista zleceń', nav_job_lifecycle: 'Cykl życia zlecenia',
    nav_warranty_codes: 'Kody gwarancyjne', nav_product_catalog: 'Katalog produktów',
    nav_resellers: 'Sprzedawcy', nav_clients: 'Klienci', nav_analytics: 'Analityka',
    nav_reports: 'Raporty', nav_notifications: 'Powiadomienia', nav_metrics: 'Metryki',
    nav_intl_reference: 'Ref. międzynarodowa', nav_floor_simulator: 'Symulator podłogi',
    nav_new_job: 'Nowe zlecenie', nav_photo_visibility: 'Widoczność zdjęć',
    nav_warranty_inventory: 'Inwentarz gwarancji', nav_warranty_scan: 'Skan gwarancji',
    nav_history: 'Historia', nav_code_inventory: 'Inwentarz kodów',
    nav_assign_installers: 'Przypisz instalatorów', nav_advanced_reports: 'Zaawansowane raporty',
    nav_client_database: 'Baza klientów', nav_performance_reports: 'Raporty wydajności',
    nav_batch_management: 'Zarządzanie partiami', nav_sports_floor_portfolio: 'Portfolio podłóg sportowych',
    nav_sign_out: 'Wyloguj się', nav_job_checklist: 'Lista kontrolna',
    save: 'Zapisz', cancel: 'Anuluj', delete: 'Usuń', edit: 'Edytuj', add: 'Dodaj',
    search: 'Szukaj', filter: 'Filtruj', export: 'Eksportuj', close: 'Zamknij',
    confirm: 'Potwierdź', back: 'Wstecz', next: 'Dalej', submit: 'Wyślij', loading: 'Ładowanie...',
    no_data: 'Brak dostępnych danych', yes: 'Tak', no: 'Nie', ok: 'OK',
    error: 'Błąd', success: 'Sukces', warning: 'Ostrzeżenie',
    status_active: 'Aktywny', status_inactive: 'Nieaktywny', status_pending: 'Oczekujący',
    status_completed: 'Ukończony', status_in_progress: 'W toku', status_cancelled: 'Anulowany',
    status_expired: 'Wygasły', status_valid: 'Ważny', status_invalid: 'Nieważny',
    dashboard_title: 'Panel', dashboard_welcome: 'Witamy',
    login_title: 'Witamy ponownie', login_subtitle: 'Zaloguj się do swojego konta MyFloorID',
    login_email: 'Adres e-mail', login_email_placeholder: 'Wprowadź swój e-mail',
    login_password: 'Hasło', login_password_placeholder: 'Wprowadź swoje hasło',
    login_remember_me: 'Zapamiętaj mnie', login_forgot_password: 'Zapomniałeś hasła?',
    login_sign_in: 'Zaloguj się', login_signing_in: 'Logowanie...',
    login_accept_sign_in: 'Akceptuj i zaloguj się',
    login_privacy_policy: 'Polityka prywatności', login_terms: 'Warunki usługi',
    login_need_help: 'Potrzebujesz pomocy? Skontaktuj się', login_all_rights: 'Wszelkie prawa zastrzeżone.',
    login_error_email_required: 'Adres e-mail jest wymagany',
    login_error_email_invalid: 'Wprowadź prawidłowy adres e-mail',
    login_error_password_required: 'Hasło jest wymagane',
    login_error_password_length: 'Hasło musi mieć co najmniej 8 znaków',
    login_error_invalid_credentials: 'Nieprawidłowy e-mail lub hasło.',
    login_error_network: 'Błąd sieci. Spróbuj ponownie.',
    product_catalog_title: 'Zarządzanie katalogiem produktów', product_catalog_add: 'Dodaj produkt',
    product_catalog_search: 'Szukaj produktów...', product_catalog_all_categories: 'Wszystkie kategorie',
    product_catalog_cleaners: 'Środki czyszczące', product_catalog_sealers: 'Uszczelniacze & Powłoki',
    product_catalog_maintenance: 'Produkty konserwacyjne', product_catalog_tools: 'Narzędzia & Sprzęt',
    product_catalog_polish: 'Polerowanie & Wykończenie',
    qr_validating: 'Weryfikacja kodu QR...', qr_invalid_title: 'Nieprawidłowy kod QR',
    qr_invalid_desc: 'Ten kod QR nie jest rozpoznany lub został dezaktywowany.',
    qr_go_login: 'Przejdź do logowania', qr_verified: 'Zweryfikowany',
    qr_floor_maintenance: 'Informacje o konserwacji podłogi', qr_verified_by: 'Zweryfikowany przez Dr.Schutz',
    qr_before: 'Przed', qr_after: 'Po', qr_floor_type: 'Typ podłogi',
    qr_installation_date: 'Data instalacji', qr_work_summary: 'Podsumowanie prac',
    qr_products_used: 'Użyte produkty', qr_performed_by: 'Prace wykonał',
    qr_maintenance_status: 'Status konserwacji', qr_next_inspection: 'Następna inspekcja',
    qr_warranty_status: 'Status gwarancji', qr_valid_until: 'Ważny do',
    notifications_title: 'Powiadomienia', notifications_mark_all_read: 'Oznacz wszystkie jako przeczytane',
    notifications_no_notifications: 'Brak powiadomień',
    checklist_title: 'Lista kontrolna', checklist_pre_job: 'Przed zleceniem', checklist_post_job: 'Po zleceniu',
    intl_ref_title: 'Międzynarodowa lista referencyjna', intl_ref_country: 'Kraj',
    footer_rights: 'Wszelkie prawa zastrzeżone.', language_select: 'Wybierz język',
    page_not_found: 'Strona nie znaleziona', go_home: 'Strona główna',
  },

  fi: {
    nav_dashboard: 'Kojelauta', nav_job_list: 'Töiden lista', nav_job_lifecycle: 'Työn elinkaari',
    nav_warranty_codes: 'Takuukoodit', nav_product_catalog: 'Tuotekatalogi',
    nav_resellers: 'Jälleenmyyjät', nav_clients: 'Asiakkaat', nav_analytics: 'Analytiikka',
    nav_reports: 'Raportit', nav_notifications: 'Ilmoitukset', nav_metrics: 'Mittarit',
    nav_intl_reference: 'Kansainv. viite', nav_floor_simulator: 'Lattiasimulaattori',
    nav_new_job: 'Uusi työ', nav_photo_visibility: 'Kuvien näkyvyys',
    nav_warranty_inventory: 'Takuuvarasto', nav_warranty_scan: 'Takuuskannaus',
    nav_history: 'Historia', nav_code_inventory: 'Koodivarasto',
    nav_assign_installers: 'Määritä asentajat', nav_advanced_reports: 'Edistyneet raportit',
    nav_client_database: 'Asiakastietokanta', nav_performance_reports: 'Suorituskykyraportit',
    nav_batch_management: 'Erähallinnointi', nav_sports_floor_portfolio: 'Urheilulattiaportfolio',
    nav_sign_out: 'Kirjaudu ulos', nav_job_checklist: 'Tarkistuslista',
    save: 'Tallenna', cancel: 'Peruuta', delete: 'Poista', edit: 'Muokkaa', add: 'Lisää',
    search: 'Hae', filter: 'Suodata', export: 'Vie', close: 'Sulje',
    confirm: 'Vahvista', back: 'Takaisin', next: 'Seuraava', submit: 'Lähetä', loading: 'Ladataan...',
    no_data: 'Ei tietoja saatavilla', yes: 'Kyllä', no: 'Ei', ok: 'OK',
    error: 'Virhe', success: 'Onnistui', warning: 'Varoitus',
    status_active: 'Aktiivinen', status_inactive: 'Ei aktiivinen', status_pending: 'Odottaa',
    status_completed: 'Valmis', status_in_progress: 'Käynnissä', status_cancelled: 'Peruutettu',
    status_expired: 'Vanhentunut', status_valid: 'Voimassa', status_invalid: 'Virheellinen',
    dashboard_title: 'Kojelauta', dashboard_welcome: 'Tervetuloa',
    login_title: 'Tervetuloa takaisin', login_subtitle: 'Kirjaudu MyFloorID-tilillesi',
    login_email: 'Sähköpostiosoite', login_email_placeholder: 'Syötä sähköpostisi',
    login_password: 'Salasana', login_password_placeholder: 'Syötä salasanasi',
    login_remember_me: 'Muista minut', login_forgot_password: 'Unohditko salasanan?',
    login_sign_in: 'Kirjaudu sisään', login_signing_in: 'Kirjaudutaan...',
    login_accept_sign_in: 'Hyväksy ja kirjaudu',
    login_privacy_policy: 'Tietosuojakäytäntö', login_terms: 'Käyttöehdot',
    login_need_help: 'Tarvitsetko apua? Ota yhteyttä', login_all_rights: 'Kaikki oikeudet pidätetään.',
    login_error_email_required: 'Sähköpostiosoite vaaditaan',
    login_error_email_invalid: 'Syötä kelvollinen sähköpostiosoite',
    login_error_password_required: 'Salasana vaaditaan',
    login_error_password_length: 'Salasanan on oltava vähintään 8 merkkiä',
    login_error_invalid_credentials: 'Virheellinen sähköposti tai salasana.',
    login_error_network: 'Verkkovirhe. Yritä uudelleen.',
    product_catalog_title: 'Tuotekatalogin hallinta', product_catalog_add: 'Lisää tuote',
    product_catalog_search: 'Hae tuotteita...', product_catalog_all_categories: 'Kaikki kategoriat',
    product_catalog_cleaners: 'Puhdistusaineet', product_catalog_sealers: 'Tiivisteet & Pinnoitteet',
    product_catalog_maintenance: 'Huoltotuotteet', product_catalog_tools: 'Työkalut & Varusteet',
    product_catalog_polish: 'Kiillotus & Viimeistely',
    qr_validating: 'Vahvistetaan QR-koodia...', qr_invalid_title: 'Virheellinen QR-koodi',
    qr_invalid_desc: 'Tätä QR-koodia ei tunnisteta tai se on poistettu käytöstä.',
    qr_go_login: 'Siirry kirjautumiseen', qr_verified: 'Vahvistettu',
    qr_floor_maintenance: 'Lattian huoltotiedot', qr_verified_by: 'Vahvistanut Dr.Schutz',
    qr_before: 'Ennen', qr_after: 'Jälkeen', qr_floor_type: 'Lattiatyyppi',
    qr_installation_date: 'Asennuspäivä', qr_work_summary: 'Työn yhteenveto',
    qr_products_used: 'Käytetyt tuotteet', qr_performed_by: 'Työn suoritti',
    qr_maintenance_status: 'Huoltotila', qr_next_inspection: 'Seuraava tarkastus',
    qr_warranty_status: 'Takuutila', qr_valid_until: 'Voimassa',
    notifications_title: 'Ilmoitukset', notifications_mark_all_read: 'Merkitse kaikki luetuiksi',
    notifications_no_notifications: 'Ei ilmoituksia',
    checklist_title: 'Tarkistuslista', checklist_pre_job: 'Ennen työtä', checklist_post_job: 'Työn jälkeen',
    intl_ref_title: 'Kansainvälinen viitelista', intl_ref_country: 'Maa',
    footer_rights: 'Kaikki oikeudet pidätetään.', language_select: 'Valitse kieli',
    page_not_found: 'Sivua ei löydy', go_home: 'Etusivu',
  },

  sv: {
    nav_dashboard: 'Instrumentpanel', nav_job_list: 'Jobblista', nav_job_lifecycle: 'Jobblivscykel',
    nav_warranty_codes: 'Garantikoder', nav_product_catalog: 'Produktkatalog',
    nav_resellers: 'Återförsäljare', nav_clients: 'Kunder', nav_analytics: 'Analys',
    nav_reports: 'Rapporter', nav_notifications: 'Aviseringar', nav_metrics: 'Mätvärden',
    nav_intl_reference: 'Intl. referens', nav_floor_simulator: 'Golvsimulatorn',
    nav_new_job: 'Nytt jobb', nav_photo_visibility: 'Fotosynlighet',
    nav_warranty_inventory: 'Garantilager', nav_warranty_scan: 'Garantiskanning',
    nav_history: 'Historik', nav_code_inventory: 'Kodlager',
    nav_assign_installers: 'Tilldela installatörer', nav_advanced_reports: 'Avancerade rapporter',
    nav_client_database: 'Kunddatabas', nav_performance_reports: 'Prestandarapporter',
    nav_batch_management: 'Batchhantering', nav_sports_floor_portfolio: 'Sportgolvportfölj',
    nav_sign_out: 'Logga ut', nav_job_checklist: 'Checklista',
    save: 'Spara', cancel: 'Avbryt', delete: 'Ta bort', edit: 'Redigera', add: 'Lägg till',
    search: 'Sök', filter: 'Filtrera', export: 'Exportera', close: 'Stäng',
    confirm: 'Bekräfta', back: 'Tillbaka', next: 'Nästa', submit: 'Skicka', loading: 'Laddar...',
    no_data: 'Inga data tillgängliga', yes: 'Ja', no: 'Nej', ok: 'OK',
    error: 'Fel', success: 'Framgång', warning: 'Varning',
    status_active: 'Aktiv', status_inactive: 'Inaktiv', status_pending: 'Väntande',
    status_completed: 'Slutförd', status_in_progress: 'Pågår', status_cancelled: 'Avbruten',
    status_expired: 'Utgången', status_valid: 'Giltig', status_invalid: 'Ogiltig',
    dashboard_title: 'Instrumentpanel', dashboard_welcome: 'Välkommen',
    login_title: 'Välkommen tillbaka', login_subtitle: 'Logga in på ditt MyFloorID-konto',
    login_email: 'E-postadress', login_email_placeholder: 'Ange din e-post',
    login_password: 'Lösenord', login_password_placeholder: 'Ange ditt lösenord',
    login_remember_me: 'Kom ihåg mig', login_forgot_password: 'Glömt lösenordet?',
    login_sign_in: 'Logga in', login_signing_in: 'Loggar in...',
    login_accept_sign_in: 'Acceptera och logga in',
    login_privacy_policy: 'Integritetspolicy', login_terms: 'Användarvillkor',
    login_need_help: 'Behöver du hjälp? Kontakta', login_all_rights: 'Alla rättigheter förbehållna.',
    login_error_email_required: 'E-postadress krävs',
    login_error_email_invalid: 'Ange en giltig e-postadress',
    login_error_password_required: 'Lösenord krävs',
    login_error_password_length: 'Lösenordet måste vara minst 8 tecken',
    login_error_invalid_credentials: 'Ogiltig e-post eller lösenord.',
    login_error_network: 'Nätverksfel. Försök igen.',
    product_catalog_title: 'Produktkataloghantering', product_catalog_add: 'Lägg till produkt',
    product_catalog_search: 'Sök produkter...', product_catalog_all_categories: 'Alla kategorier',
    product_catalog_cleaners: 'Rengöringsmedel', product_catalog_sealers: 'Tätningsmedel & Beläggningar',
    product_catalog_maintenance: 'Underhållsprodukter', product_catalog_tools: 'Verktyg & Utrustning',
    product_catalog_polish: 'Polering & Finish',
    qr_validating: 'Validerar QR-kod...', qr_invalid_title: 'Ogiltig QR-kod',
    qr_invalid_desc: 'Denna QR-kod känns inte igen eller har inaktiverats.',
    qr_go_login: 'Gå till inloggning', qr_verified: 'Verifierad',
    qr_floor_maintenance: 'Golvunderhållsinformation', qr_verified_by: 'Verifierad av Dr.Schutz',
    qr_before: 'Före', qr_after: 'Efter', qr_floor_type: 'Golvtyp',
    qr_installation_date: 'Installationsdatum', qr_work_summary: 'Arbetssammanfattning',
    qr_products_used: 'Använda produkter', qr_performed_by: 'Arbete utfört av',
    qr_maintenance_status: 'Underhållsstatus', qr_next_inspection: 'Nästa inspektion',
    qr_warranty_status: 'Garantistatus', qr_valid_until: 'Giltig till',
    notifications_title: 'Aviseringar', notifications_mark_all_read: 'Markera alla som lästa',
    notifications_no_notifications: 'Inga aviseringar',
    checklist_title: 'Checklista', checklist_pre_job: 'Före jobbet', checklist_post_job: 'Efter jobbet',
    intl_ref_title: 'Internationell referenslista', intl_ref_country: 'Land',
    footer_rights: 'Alla rättigheter förbehållna.', language_select: 'Välj språk',
    page_not_found: 'Sidan hittades inte', go_home: 'Hem',
  },

  nl: {
    nav_dashboard: 'Dashboard', nav_job_list: 'Takenlijst', nav_job_lifecycle: 'Taaklevenscyclus',
    nav_warranty_codes: 'Garantiecodes', nav_product_catalog: 'Productcatalogus',
    nav_resellers: 'Wederverkopers', nav_clients: 'Klanten', nav_analytics: 'Analyse',
    nav_reports: 'Rapporten', nav_notifications: 'Meldingen', nav_metrics: 'Statistieken',
    nav_intl_reference: 'Intl. referentie', nav_floor_simulator: 'Vloersimulator',
    nav_new_job: 'Nieuwe taak', nav_photo_visibility: 'Fotovisibiliteit',
    nav_warranty_inventory: 'Garantievoorraad', nav_warranty_scan: 'Garantiescan',
    nav_history: 'Geschiedenis', nav_code_inventory: 'Codevoorraad',
    nav_assign_installers: 'Installateurs toewijzen', nav_advanced_reports: 'Geavanceerde rapporten',
    nav_client_database: 'Klantendatabase', nav_performance_reports: 'Prestatierapporten',
    nav_batch_management: 'Batchbeheer', nav_sports_floor_portfolio: 'Sportbodem portfolio',
    nav_sign_out: 'Uitloggen', nav_job_checklist: 'Controlelijst',
    save: 'Opslaan', cancel: 'Annuleren', delete: 'Verwijderen', edit: 'Bewerken', add: 'Toevoegen',
    search: 'Zoeken', filter: 'Filteren', export: 'Exporteren', close: 'Sluiten',
    confirm: 'Bevestigen', back: 'Terug', next: 'Volgende', submit: 'Indienen', loading: 'Laden...',
    no_data: 'Geen gegevens beschikbaar', yes: 'Ja', no: 'Nee', ok: 'OK',
    error: 'Fout', success: 'Succes', warning: 'Waarschuwing',
    status_active: 'Actief', status_inactive: 'Inactief', status_pending: 'In behandeling',
    status_completed: 'Voltooid', status_in_progress: 'Bezig', status_cancelled: 'Geannuleerd',
    status_expired: 'Verlopen', status_valid: 'Geldig', status_invalid: 'Ongeldig',
    dashboard_title: 'Dashboard', dashboard_welcome: 'Welkom',
    login_title: 'Welkom terug', login_subtitle: 'Log in op uw MyFloorID-account',
    login_email: 'E-mailadres', login_email_placeholder: 'Voer uw e-mail in',
    login_password: 'Wachtwoord', login_password_placeholder: 'Voer uw wachtwoord in',
    login_remember_me: 'Onthoud mij', login_forgot_password: 'Wachtwoord vergeten?',
    login_sign_in: 'Inloggen', login_signing_in: 'Inloggen...',
    login_accept_sign_in: 'Accepteren en inloggen',
    login_privacy_policy: 'Privacybeleid', login_terms: 'Servicevoorwaarden',
    login_need_help: 'Hulp nodig? Neem contact op', login_all_rights: 'Alle rechten voorbehouden.',
    login_error_email_required: 'E-mailadres is vereist',
    login_error_email_invalid: 'Voer een geldig e-mailadres in',
    login_error_password_required: 'Wachtwoord is vereist',
    login_error_password_length: 'Wachtwoord moet minimaal 8 tekens bevatten',
    login_error_invalid_credentials: 'Ongeldig e-mail of wachtwoord.',
    login_error_network: 'Netwerkfout. Probeer opnieuw.',
    product_catalog_title: 'Productcatalogus beheer', product_catalog_add: 'Product toevoegen',
    product_catalog_search: 'Producten zoeken...', product_catalog_all_categories: 'Alle categorieën',
    product_catalog_cleaners: 'Reinigingsmiddelen', product_catalog_sealers: 'Afdichtingen & Coatings',
    product_catalog_maintenance: 'Onderhoudsproducten', product_catalog_tools: 'Gereedschap & Uitrusting',
    product_catalog_polish: 'Poetsmiddel & Afwerking',
    qr_validating: 'QR-code valideren...', qr_invalid_title: 'Ongeldige QR-code',
    qr_invalid_desc: 'Deze QR-code wordt niet herkend of is gedeactiveerd.',
    qr_go_login: 'Ga naar inloggen', qr_verified: 'Geverifieerd',
    qr_floor_maintenance: 'Vloeronderhoudsinformatie', qr_verified_by: 'Geverifieerd door Dr.Schutz',
    qr_before: 'Voor', qr_after: 'Na', qr_floor_type: 'Vloertype',
    qr_installation_date: 'Installatiedatum', qr_work_summary: 'Werkoverzicht',
    qr_products_used: 'Gebruikte producten', qr_performed_by: 'Werk uitgevoerd door',
    qr_maintenance_status: 'Onderhoudsstatus', qr_next_inspection: 'Volgende inspectie',
    qr_warranty_status: 'Garantiestatus', qr_valid_until: 'Geldig tot',
    notifications_title: 'Meldingen', notifications_mark_all_read: 'Alles als gelezen markeren',
    notifications_no_notifications: 'Geen meldingen',
    checklist_title: 'Controlelijst', checklist_pre_job: 'Voor de taak', checklist_post_job: 'Na de taak',
    intl_ref_title: 'Internationale referentielijst', intl_ref_country: 'Land',
    footer_rights: 'Alle rechten voorbehouden.', language_select: 'Taal selecteren',
    page_not_found: 'Pagina niet gevonden', go_home: 'Home',
  },

  es: {
    nav_dashboard: 'Panel', nav_job_list: 'Lista de trabajos', nav_job_lifecycle: 'Ciclo de vida',
    nav_warranty_codes: 'Códigos de garantía', nav_product_catalog: 'Catálogo de productos',
    nav_resellers: 'Revendedores', nav_clients: 'Clientes', nav_analytics: 'Análisis',
    nav_reports: 'Informes', nav_notifications: 'Notificaciones', nav_metrics: 'Métricas',
    nav_intl_reference: 'Ref. internacional', nav_floor_simulator: 'Simulador de suelo',
    nav_new_job: 'Nuevo trabajo', nav_photo_visibility: 'Visibilidad de fotos',
    nav_warranty_inventory: 'Inventario de garantía', nav_warranty_scan: 'Escaneo de garantía',
    nav_history: 'Historial', nav_code_inventory: 'Inventario de códigos',
    nav_assign_installers: 'Asignar instaladores', nav_advanced_reports: 'Informes avanzados',
    nav_client_database: 'Base de datos de clientes', nav_performance_reports: 'Informes de rendimiento',
    nav_batch_management: 'Gestión de lotes', nav_sports_floor_portfolio: 'Portafolio de suelos deportivos',
    nav_sign_out: 'Cerrar sesión', nav_job_checklist: 'Lista de verificación',
    save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar', edit: 'Editar', add: 'Agregar',
    search: 'Buscar', filter: 'Filtrar', export: 'Exportar', close: 'Cerrar',
    confirm: 'Confirmar', back: 'Atrás', next: 'Siguiente', submit: 'Enviar', loading: 'Cargando...',
    no_data: 'No hay datos disponibles', yes: 'Sí', no: 'No', ok: 'OK',
    error: 'Error', success: 'Éxito', warning: 'Advertencia',
    status_active: 'Activo', status_inactive: 'Inactivo', status_pending: 'Pendiente',
    status_completed: 'Completado', status_in_progress: 'En progreso', status_cancelled: 'Cancelado',
    status_expired: 'Expirado', status_valid: 'Válido', status_invalid: 'Inválido',
    dashboard_title: 'Panel', dashboard_welcome: 'Bienvenido',
    login_title: 'Bienvenido de nuevo', login_subtitle: 'Inicia sesión en tu cuenta MyFloorID',
    login_email: 'Dirección de correo', login_email_placeholder: 'Ingresa tu correo',
    login_password: 'Contraseña', login_password_placeholder: 'Ingresa tu contraseña',
    login_remember_me: 'Recuérdame', login_forgot_password: '¿Olvidaste tu contraseña?',
    login_sign_in: 'Iniciar sesión', login_signing_in: 'Iniciando sesión...',
    login_accept_sign_in: 'Aceptar e iniciar sesión',
    login_privacy_policy: 'Política de privacidad', login_terms: 'Términos de servicio',
    login_need_help: '¿Necesitas ayuda? Contacta', login_all_rights: 'Todos los derechos reservados.',
    login_error_email_required: 'La dirección de correo es obligatoria',
    login_error_email_invalid: 'Por favor ingresa una dirección de correo válida',
    login_error_password_required: 'La contraseña es obligatoria',
    login_error_password_length: 'La contraseña debe tener al menos 8 caracteres',
    login_error_invalid_credentials: 'Correo o contraseña inválidos.',
    login_error_network: 'Error de red. Por favor intenta de nuevo.',
    product_catalog_title: 'Gestión del catálogo de productos', product_catalog_add: 'Agregar producto',
    product_catalog_search: 'Buscar productos...', product_catalog_all_categories: 'Todas las categorías',
    product_catalog_cleaners: 'Limpiadores', product_catalog_sealers: 'Selladores & Recubrimientos',
    product_catalog_maintenance: 'Productos de mantenimiento', product_catalog_tools: 'Herramientas & Equipos',
    product_catalog_polish: 'Pulido & Acabado',
    qr_validating: 'Validando código QR...', qr_invalid_title: 'Código QR inválido',
    qr_invalid_desc: 'Este código QR no es reconocido o ha sido desactivado.',
    qr_go_login: 'Ir al inicio de sesión', qr_verified: 'Verificado',
    qr_floor_maintenance: 'Información de mantenimiento del suelo', qr_verified_by: 'Verificado por Dr.Schutz',
    qr_before: 'Antes', qr_after: 'Después', qr_floor_type: 'Tipo de suelo',
    qr_installation_date: 'Fecha de instalación', qr_work_summary: 'Resumen del trabajo',
    qr_products_used: 'Productos utilizados', qr_performed_by: 'Trabajo realizado por',
    qr_maintenance_status: 'Estado de mantenimiento', qr_next_inspection: 'Próxima inspección',
    qr_warranty_status: 'Estado de garantía', qr_valid_until: 'Válido hasta',
    notifications_title: 'Notificaciones', notifications_mark_all_read: 'Marcar todo como leído',
    notifications_no_notifications: 'Sin notificaciones',
    checklist_title: 'Lista de verificación', checklist_pre_job: 'Antes del trabajo', checklist_post_job: 'Después del trabajo',
    intl_ref_title: 'Lista de referencia internacional', intl_ref_country: 'País',
    footer_rights: 'Todos los derechos reservados.', language_select: 'Seleccionar idioma',
    page_not_found: 'Página no encontrada', go_home: 'Inicio',
  },

  sl: {
    nav_dashboard: 'Nadzorna plošča', nav_job_list: 'Seznam del', nav_job_lifecycle: 'Življenjski cikel dela',
    nav_warranty_codes: 'Garancijske kode', nav_product_catalog: 'Katalog izdelkov',
    nav_resellers: 'Prodajalci', nav_clients: 'Stranke', nav_analytics: 'Analitika',
    nav_reports: 'Poročila', nav_notifications: 'Obvestila', nav_metrics: 'Metrike',
    nav_intl_reference: 'Mednar. referenca', nav_floor_simulator: 'Simulator tal',
    nav_new_job: 'Novo delo', nav_photo_visibility: 'Vidnost fotografij',
    nav_warranty_inventory: 'Zalog garancij', nav_warranty_scan: 'Skeniranje garancije',
    nav_history: 'Zgodovina', nav_code_inventory: 'Zalog kod',
    nav_assign_installers: 'Dodeli monterje', nav_advanced_reports: 'Napredna poročila',
    nav_client_database: 'Baza strank', nav_performance_reports: 'Poročila o uspešnosti',
    nav_batch_management: 'Upravljanje serij', nav_sports_floor_portfolio: 'Portfolio športnih tal',
    nav_sign_out: 'Odjava', nav_job_checklist: 'Kontrolni seznam',
    save: 'Shrani', cancel: 'Prekliči', delete: 'Izbriši', edit: 'Uredi', add: 'Dodaj',
    search: 'Iskanje', filter: 'Filtriraj', export: 'Izvozi', close: 'Zapri',
    confirm: 'Potrdi', back: 'Nazaj', next: 'Naprej', submit: 'Pošlji', loading: 'Nalaganje...',
    no_data: 'Ni razpoložljivih podatkov', yes: 'Da', no: 'Ne', ok: 'V redu',
    error: 'Napaka', success: 'Uspeh', warning: 'Opozorilo',
    status_active: 'Aktivno', status_inactive: 'Neaktivno', status_pending: 'V čakanju',
    status_completed: 'Dokončano', status_in_progress: 'V teku', status_cancelled: 'Preklicano',
    status_expired: 'Poteklo', status_valid: 'Veljavno', status_invalid: 'Neveljavno',
    dashboard_title: 'Nadzorna plošča', dashboard_welcome: 'Dobrodošli',
    login_title: 'Dobrodošli nazaj', login_subtitle: 'Prijavite se v svoj račun MyFloorID',
    login_email: 'E-poštni naslov', login_email_placeholder: 'Vnesite e-pošto',
    login_password: 'Geslo', login_password_placeholder: 'Vnesite geslo',
    login_remember_me: 'Zapomni si me', login_forgot_password: 'Ste pozabili geslo?',
    login_sign_in: 'Prijava', login_signing_in: 'Prijavljanje...',
    login_accept_sign_in: 'Sprejmi in se prijavi',
    login_privacy_policy: 'Politika zasebnosti', login_terms: 'Pogoji storitve',
    login_need_help: 'Potrebujete pomoč? Kontaktirajte', login_all_rights: 'Vse pravice pridržane.',
    login_error_email_required: 'E-poštni naslov je obvezen',
    login_error_email_invalid: 'Vnesite veljaven e-poštni naslov',
    login_error_password_required: 'Geslo je obvezno',
    login_error_password_length: 'Geslo mora imeti vsaj 8 znakov',
    login_error_invalid_credentials: 'Neveljavna e-pošta ali geslo.',
    login_error_network: 'Napaka omrežja. Poskusite znova.',
    product_catalog_title: 'Upravljanje kataloga izdelkov', product_catalog_add: 'Dodaj izdelek',
    product_catalog_search: 'Iskanje izdelkov...', product_catalog_all_categories: 'Vse kategorije',
    product_catalog_cleaners: 'Čistila', product_catalog_sealers: 'Tesnila & Premazi',
    product_catalog_maintenance: 'Vzdrževalni izdelki', product_catalog_tools: 'Orodja & Oprema',
    product_catalog_polish: 'Poliranje & Zaključek',
    qr_validating: 'Preverjanje QR kode...', qr_invalid_title: 'Neveljavna QR koda',
    qr_invalid_desc: 'Ta QR koda ni prepoznana ali je bila deaktivirana.',
    qr_go_login: 'Pojdi na prijavo', qr_verified: 'Preverjeno',
    qr_floor_maintenance: 'Informacije o vzdrževanju tal', qr_verified_by: 'Preverjeno s strani Dr.Schutz',
    qr_before: 'Pred', qr_after: 'Po', qr_floor_type: 'Vrsta tal',
    qr_installation_date: 'Datum namestitve', qr_work_summary: 'Povzetek del',
    qr_products_used: 'Uporabljeni izdelki', qr_performed_by: 'Dela opravil',
    qr_maintenance_status: 'Status vzdrževanja', qr_next_inspection: 'Naslednji pregled',
    qr_warranty_status: 'Status garancije', qr_valid_until: 'Veljavno do',
    notifications_title: 'Obvestila', notifications_mark_all_read: 'Označi vse kot prebrano',
    notifications_no_notifications: 'Ni obvestil',
    checklist_title: 'Kontrolni seznam', checklist_pre_job: 'Pred delom', checklist_post_job: 'Po delu',
    intl_ref_title: 'Mednarodna referenčna lista', intl_ref_country: 'Država',
    footer_rights: 'Vse pravice pridržane.', language_select: 'Izberi jezik',
    page_not_found: 'Stran ni najdena', go_home: 'Domov',
  },
};
